import styled from 'styled-components';

export { PageWrapper, FormWrapper } from '@monorepo/shared-lib';

export const EntityDetailsWrapper = styled.div`
  .top-wrapper {
    position: fixed;
    z-index: 20;
    top: 70px;
    inset-inline-end: 43px;
    inset-inline-start: calc(var(--app-sidebar-width, 213px) + 16px);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px 16px;
    max-width: calc(100vw - var(--app-sidebar-width, 213px) - 59px);
    box-sizing: border-box;
    overflow: visible;
    pointer-events: none;

    > * {
      pointer-events: auto;
      flex-shrink: 0;
    }
  }

  .top-wrapper-vies {
    position: fixed;
    z-index: -1;
    top: 70px;
    inset-inline-end: 43px;
    display: flex;
  }

  .ant-tabs-nav-wrap {
    padding: 0 40px;
  }

  .ant-tabs-nav {
    margin: 0 !important;
    position: fixed;
    width: 100%;
    height: 50px;
    z-index: 10;
    background: white;
  }
  .ant-tabs-content,
  .ant-tabs-content-holder {
    position: relative;
    z-index: 0;
  }
  .ant-tabs-content {
    margin-top: 50px;
  }

  .ant-collapse-borderless {
    background-color: white !important;
  }

  .ant-tabs-extra-content {
    margin-bottom: 10px;
    padding-right: 35px;
  }

  .expired-due-date {
    color: var(--color-status-danger, #d13131) !important;
  }

  @media (min-width: 1700px) {
    .ant-col-xxl-offset-2 {
      margin-inline-start: 4.333333333333332% !important;
    }
  }

  @media (min-width: 1920px) {
    .ant-col-xxl-offset-2 {
      margin-inline-start: 12.333333333333332% !important;
    }
  }

  @media (min-width: 2304px) {
    .ant-col-xxl-offset-2 {
      margin-inline-start: 18.333333333333332% !important;
    }
  }
`;

export const ProfileWrapper = styled.div`
  padding: 40px;
  background-color: var(--color-surface, #f3f7f8);
  min-height: calc(100vh - 70px);

  @media (min-width: 1920px) {
    .ant-col-xxl-offset-2 {
      margin-inline-start: 12.333333333333332% !important;
    }
  }

  @media (min-width: 2304px) {
    .ant-col-xxl-offset-2 {
      margin-inline-start: 18.333333333333332% !important;
    }
  }
`;

export const ActivityLogsWrapper = styled.div`
  width: 100%;
  color: var(--color-text-base, #2e2e2e);

  && .scope-round-input.ant-input-affix-wrapper {
    background: var(--color-surface, #f3f7f8) !important;

    .ant-input,
    input {
      color: var(--color-text-base, #2e2e2e) !important;
    }

    .ant-input::placeholder,
    input::placeholder {
      color: var(--color-placeholder, #5a6a6a) !important;
      opacity: 1 !important;
    }

    .scope-input-suffix-action {
      background-color: var(--color-primary, #41aaaf) !important;
      color: var(--color-on-primary, #052325) !important;
    }
  }

  html[data-theme='dark'] & {
    && .scope-round-input.ant-input-affix-wrapper {
      background: var(--color-surface, #132122) !important;
      border-color: var(--color-border, #355356) !important;

      .ant-input,
      input {
        color: var(--color-text-base, #e3eaeb) !important;
      }

      .ant-input::placeholder,
      input::placeholder {
        color: var(--color-placeholder, #8ea1a2) !important;
        opacity: 1 !important;
      }

      .scope-input-suffix-action {
        background-color: var(--color-primary, #62c8cd) !important;
        color: var(--color-on-primary, #052325) !important;
      }
    }
  }

  .ant-btn {
    color: var(--color-text-base, #2e2e2e);

    svg,
    svg path {
      stroke: currentColor;
      fill: currentColor;
    }
  }

  .vies-logs-card {
    border-radius: 10px;
    opacity: 0px;
    background: var(--color-surface-raised, #ffffff);
    border: 1px solid var(--color-border, #dbeae3);
    padding: 15px 10px 15px 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    width: 100%;
  }
  
  .vies-logs-card-details {
    width: 255px !important;
  }
  .title-date {
    font-family: var(--font-family, Inter, sans-serif);
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    color: var(--color-text-base, #2e2e2e);
  }
  .user-box {
    display: flex;
    align-items: center;
    gap: 15px;
    //margin-bottom: 15px;
  }
  .date-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--color-border, #dbeae3);
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .data-row-details {
  .date-row
    flex-wrap: wrap;
    max-width: 250px;
  }
  .invoice-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--color-text-muted, #5a6a6a);
  }

  .invoice-box{
    display: flex;
    align-items: center;
    margin-right: 10px;
    height: 30px;
    border-radius: 5px;
    background: var(--color-layout-bg, #e9f6f7);
    padding: 0px 10px;
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    width: fit-content;
  }  
`;
